import Question1 from './question1.svg';
import Question2 from './question2.svg';
import Question3 from './question3.svg';
import Question4 from './question4.svg';
import Question5 from './question5.png';
import Question6 from './question6.svg';
import Question7 from './question7.jpg';
import Question8 from './question8.svg';
import Question9 from './question9.jpg';
import Question10 from './question10.jpg';

export const questionContent = [
  {
    text: 'Утром вы проснулись, потянулись выключить будильник на телефоне и заметили сообщение от друга:',
    question: 'Что будете делать?',
    src: Question1,
    answers: [
      {
        value: 'У него наверняка проблемы — надо срочно помочь!',
        isRight: false
      },
      {
        value:'У меня столько нет. Попробую одолжить, сколько смогу',
        isRight: false
      },
      {
        value:'Что-то не похоже на моего друга. Надо бы лично спросить, что случилось',
        isRight: true
      }
    ]
  },
  {
    text: 'Что ж, теперь можно и соцсети полистать. О, кто-то откомментил ваше селфи! Только не очень лестно...',
    question: 'Что будете делать?',
    src: Question2,
    answers: [
      {
        value: 'Не буду отвечать: мало ли, кто что думает',
        isRight: true
      },
      {
        value: 'Оскорблю в ответ — надо поставить на место негодяя',
        isRight: false
      },
      {
        value: 'Попробую нейтрализовать хама вежливым ответом',
        isRight: false
      }
    ]
  },
  {
    text: 'А что там по новостям? Ого, неудивительно, что такая спорная история оказалась  в топе...',
    question: 'Руки так и тянутся написать комментарий. Что бы вы в нём сказали?',
    src: Question3,
    answers: [
      {
        value: 'Фу, бред! Кошки совсем не дружелюбные. Раз хотят гулять сами по себе, пусть и гуляют по помойкам',
        isRight: false
      },
      {
        value: 'Уи-и-и, это правда! Котики — милашки, а собаки туповаты, да ещё и гулять с ними надо',
        isRight: false
      },
      {
        value: 'Не буду ввязываться в бессмысленный холивар по очевидно сомнительному поводу',
        isRight: true
      }
    ]
  },
  {
    text: 'На сайте, где вы читали новости, вдруг всплыл баннер:',
    question: 'Что предпримете?',
    src: Question4,
    answers: [
      {
        value: 'Не сейчас — антивирусы вечно всё преувеличивают. Наверняка, никакой проблемы и нет',
        isRight: false
      },
      {
        value: 'Хорошо, что предупредили! Надо срочно вылечить вирус, пока он не сломал мне комп и не украл данные',
        isRight: false
      },
      {
        value: 'А какая программа прислала это оповещение? Что-то не похоже на мой антивирус. Надо разобраться',
        isRight: true
      }
    ]
  },
  {
    text: 'После такого нужна терапия видосиками! Среди милых зверушек вы заметили интересное видео о похудении от диетолога:',
    question: 'Воспользуетесь советом?',
    src: Question5,
    imgWidth: 289,
    answers: [
      {
        value: 'Почему нет? Это же врач, а не бьюти-блогер',
        isRight: false
      },
      {
        value: 'У этого специалиста много подписчиков в соцсетях. А что о нём говорят другие врачи, которым можно доверять?',
        isRight: true
      },
      {
        value: 'А диплом у этого врача есть? А, есть. Ну, тогда всё нормально, я в деле',
        isRight: false
      }
    ]
  },
  {
    text: 'Дзинь! Ни минуты покоя, но таков уж этот интернет. Ловите важное письмо:',
    question: 'Пойдёте забирать деньги?',
    src: Question6,
    answers: [
      {
        value: 'А то! Ещё и в календаре этот день помечу: наконец государство мне платит, а не наоборот 😄',
        isRight: false
      },
      {
        value: 'Помню что-то про налоговый вычет — наверное, это он. Давайте его сюда',
        isRight: false
      },
      {
        value: 'Ничего не понятно. Пойду сам зайду в личный кабинет и проверю там, что за компенсации',
        isRight: true
      }
    ]
  },
  {
    text: 'Вы оторвались от телефона и увидели, какая красота за окном вашего дома:',
    question: 'Поделитесь фоткой в соцсетях?',
    src: Question7,
    answers: [
      {
        value: 'Да, конечно, только выкину из кадра всё лишнее',
        isRight: true
      },
      {
        value: 'Само собой! И надо ещё не забыть хэштэги и геометку, чтобы больше просмотров и лайков собрать',
        isRight: false
      },
      {
        value: 'Выложу целиком, но геометку ставить не буду, а то как поедут — на пляже места не останется',
        isRight: false
      }
    ]
  },
  {
    text: 'Кстати, о фото. Похоже, у какого-то незнакомца есть на вас компромат:',
    question: 'Как спастись от позора?',
    src: Question8,
    answers: [
      {
        value: 'Вот это палево! Похоже, ничего больше не остаётся, как перевести деньги',
        isRight: false
      },
      {
        value: 'Меня бы это здорово напрягло, посещай я эротические сайты',
        isRight: false
      },
      {
        value: 'Ой, боюсь-боюсь! Мне такие письма каждый день приходят, и пока никто не жаловался 😄',
        isRight: true
      }
    ]
  },
  {
    text: 'Ну, уж любимая онлайн-игра-то не подведёт! К тому же какие-то умельцы нашли хитрое дополнение, которое помогает быстрее повысить уровень персонажа:',
    question: 'Скачаете?',
    src: Question9,
    answers: [
      {
        value: 'Игра и так постоянно вытягивает деньги за улучшения. Схитрю в этот раз и немного сэкономлю',
        isRight: false
      },
      {
        value: 'Чего это он делится таким богатством со всеми? Подозрительно  🤨 Ну, или просто я жадина',
        isRight: true
      },
      {
        value: 'О, кайф, скину друзьям — пусть тоже прокачаются бесплатно!',
        isRight: false
      }
    ]
  },
  {
    text: 'Сложный день позади. Вы уютно устроились в кроватке:',
    question: 'Чем займётесь перед сном?',
    src: Question10,
    answers: [
      {
        value: 'Почитаю ленту за весь день — надо ведь быть в курсе событий: у друзей и в мире',
        isRight: false
      },
      {
        value: 'Включу сериальчик или кино онлайн, а там, глядишь, и усну под бормотание в экране',
        isRight: false
      },
      {
        value: 'Почитаю книгу или послушаю спокойные шумы, музыку, медитации — отлично убаюкивает',
        isRight: true
      }
    ]
  }
];
